<template>

    <div class="product-list">
        <CCard>
            <CCardHeader>
                <strong>
                    لیست  درخواست قطعه
                </strong>

            </CCardHeader>

            <CCardBody class="">
              <CRow>
                <CCol col="3">
                  <date-picker
                      display-format="jYYYY/jMM/jDD"
                     format="YYYY-MM-DD"

                      v-model="start_date"/>
                </CCol>
                <CCol col="3">
                  <date-picker
                      display-format="jYYYY/jMM/jDD"
                      format="YYYY-MM-DD"

                      v-model="end_date"/>
                </CCol>
                <CCol col="1">
                  <CButton
                      color="primary"
                  @click="get_news()">
                    جستجو
                  </CButton>
                </CCol>
              </CRow>


              <CTabs>
                <CTab :title="status.label" v-for="status in status_items">
                  <CDataTable
                      :items="items_active.filter(x=>x.status.id==status.value)"
                      :fields="fields"
column-filter
                      :items-per-page="20"
                      hover
                      sorter
                      pagination
                  >
                    <template #ردیف="{item,index}">
                      <td>
                        <p class="text-muted">{{index+1}}</p>
                      </td>
                    </template>
                    <template #summary="{item}">
                      <td>
                        <p v-if="item.summary!=null">
                          {{ item.summary }}
                        </p>
                      </td>
                    </template>
                    <template #created_at="{item}">
                      <td>
                        <p class="text-muted">{{new Date(item.created_at).toLocaleDateString('fa-IR')}}</p>
                      </td>
                    </template>
                    <template #status="{item}">
                      <td>
                        <p>
                          {{ item.status.status }}
                        </p>
                      </td>
                    </template>
                    <template #branch="{item}">
                      <td>
                        <p v-if="item.branch!=null">
                          {{ item.branch.branch.BranchName }}
                        </p>
                        <p v-else>
                          آنلاین
                        </p>
                      </td>
                    </template>
                    <template #comments="{item}">
                      <td>
                        <p>
                          {{ item.comments.comment }}
                        </p>
                      </td>
                    </template>
                    <template #images="{item}">
                      <td>
                        <p class="text-muted" v-for="image in item.images"
                        >
                          <a  :href="'https://abapart.ir/images/product_request/'+image.file_name" target="_blank" >
                            <img :src="'https://abapart.ir/images/product_request/'+image.file_name" width="100px" height="auto"/>
                          </a>
                        </p>
                      </td>
                    </template>

                    <template #عملیات="{item,index}">
                      <td class="py-2">
                        <CButton
                            color="primary"
                            variant="outline"
                            square
                            size="sm"
                            @click="goRegister(item)"
                        >نمایش
                        </CButton>

                      </td>
                    </template>



                  </CDataTable>

                </CTab>
              </CTabs>
            </CCardBody>
        </CCard>

    </div>

</template>

<script>
    import axios from "axios";
    import {bus} from "../../main";
    import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
    import moment from 'moment-jalaali'

    export default {
        name: 'Login',
        components: {
          datePicker: VuePersianDatetimePicker

          // Use the <ckeditor> component in this view.
            // ckeditor: CKEditor.component
        },
        data() {
            return {
              start_date:'',
              end_date:'',
                delete_tag:new Date()+"_delete_confirm",
                edit_row: null,
                edit_flag: false,
                edit_product_weight: '',
                name: '',
                product_weight: null,
                items_tags: [],
                items_tags_title: null,
                items_tags_id: 1,
                edit_items_tags_id: 0,
                product_weight_id: 1,
                edit_product_weight_id: 0,
                productId: null,
                file: '',
                color: '',
                weightModal: false,
                previewImage: '',
                description: '',
                weights: null,
                fields :[
                    {key: 'ردیف',label: 'ردیف', _style: 'width:5%'},
                    {key: 'created_at',label: 'تاریخ ثبت', _style: 'width:10%;'},

                    {key: 'full_name',label: 'نام مشتری', _style: 'width:10%'},
                    {key: 'mobile_no',label: 'موبایل', _style: 'width:10%'},
                    {key: 'product_name',label: 'قطعه', _style: 'width:10%;'},
                    // {key: 'images',label: 'تصاویر', _style: 'width:10%;'},
                    // {key: 'summary',label: 'توضیحات', _style: 'width:10%;'},
                    {key: 'status_title',label: 'اخرین وضعیت', _style: 'width:10%;'},
                    {key: 'branch',label: 'محل', _style: 'width:10%;'},
                    {key: 'comments',label: 'اخرین کامنت', _style: 'width:10%;'},
                    {key: 'عملیات',label: 'عملیات', _style: 'width:5%;'},

                ],

                items_active: [],
              status_items: [],
                items_process: [],
                items_in_way:  [],
                items_sent:  [],
                items_canceled:  [],
                details: [],
                collapseDuration: 0,
                status_form: 0
            }
        },
        mounted() {
          this.start_date =  moment().locale('en').subtract(30,'day').format('YYYY-MM-DD');
          this.end_date = moment().locale('en').format('YYYY-MM-DD');

            console.log("process is "+process.env.VUE_APP_BASE_URL);
            this.get_status_list();
            this.get_news();
            bus.$on(this.delete_tag, (data) => {
                // alert(data);
                if (data=='true'){
                    this.delete_item();

                }else{
                    this.status_form = 0;
                }
            });
        },
        watch: {
            '$route.params.cat_id': function (id) {
                this.get_categories();
            },


        },
        methods: {
          get_status_list() {
            var self = this;
            // console.log("route id "+this.$route.params.cat_id);
            var formData = new FormData();
            formData.append("token", localStorage.getItem("token"));

            axios.post('/api/admin/get_product_request_status', formData, {}).then(function (response) {
              self.status_items = [{label:'بدون وضعیت',value:0}]
              response.data.forEach(function (val){
                self.status_items.push({label:val.title,value:val.id})
              })

              self.selected_status = self.status_items[0].value;

            })
                .catch(function (error) {

                  console.log(error);
                });

          },

            get_style(color) {
                return {
                    myStyle: {
                        backgroundColor: color
                    }
                }
            },
            editDetails(item,index) {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.$router.push({path:"/dashboard/products/edit/"+item.post_id});
                // this.name = this.items[item.id].name
                // this.color = this.items[item.id].color
                // this.description = this.items[item.id].description
                // this.previewImage = this.items[item.id].image
                // this.status_form = this.items[item.id].cat_id;
                // // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            go_show_product(item) {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                window.open(process.env.VUE_APP_BASE_URL+"products/"+item.slug,"_blank");
                // this.$router.push({path:"/dashboard/products/edit/"+item.post_id});
                // this.name = this.items[item.id].name
                // this.color = this.items[item.id].color
                // this.description = this.items[item.id].description
                // this.previewImage = this.items[item.id].image
                // this.status_form = this.items[item.id].cat_id;
                // // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            get_news() {
                var self = this;
                // console.log("route id "+this.$route.params.cat_id);
                var formData = new FormData();
                formData.append("start_date",this.start_date)
                formData.append("end_date",this.end_date)

                formData.append('token',localStorage.getItem("token"));
                axios.post('/api/admin/get_user_product_request',formData, {}).then(function (response) {

                  response.data.data.forEach(function (val){
                    val.status_title = val.status.status
                  })

                    var data_filter = response.data.data.map((item, row_id) => {
                        return {...item, row_id}
                    });

                    self.items_active = data_filter;

                    // self.description = '';
                    // localStorage.setItem("api_token", response.data.access_token);
                    // self.$router.push({ path: 'notes' });
                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            goRegister(item) {
                console.log("item clicked",item)
              window.open('/dashboard/orders/show-user-product-requests/'+item.id);
                // this.$router.push({path: '/dashboard/orders/show-user-product-requests/'+item.id});
            },
            goAddNews() {

                this.$router.push({path: '/dashboard/products/create'});
            },
            delete_dialog(item) {
                this.$root.modal_component.show_confirm_modal('اخطار',"آیا مایل به حذف این ردیف هستید؟",['تایید'],this.delete_tag);

                this.status_form = item.post_id;
                console.log(this.status_form)

                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            delete_item(){


                let self = this;
                const formData = new FormData()
                let url;
                url = "/api/admin/product/delete";

                formData.append('token',localStorage.getItem("token"));
                formData.append('id', this.status_form);

                axios.post(url, formData, {
                }).then((res) => {
                    console.log(res);
                    if(res.data.error==1){
                        this.$root.modal_component.show_danger_modal('خطا',res.data.msg);

                    }else{
                        this.$root.modal_component.show_success_modal('تایید',res.data.msg);

                    }
                    self.status_form=0;

                    self.get_news();


                })
                    .catch(function (error) {

                        console.log(error);
                    });
            },
        }
    }


</script>
